import { Injectable } from '@angular/core';
import { EditorService } from '@app/modules/editor/services/editor.service';
import { BlockAction } from '@core/models';
import { Subject } from 'rxjs';

class ClickSubject extends Subject<BlockAction> {
  constructor(private editor: EditorService) {
    super();
  }
  override next(value: BlockAction): void {
    if (!this.editor.isEditModeEnabled()) {
      super.next(value);
    }
  }
}

@Injectable({ providedIn: 'root' })
export class ButtonHandlerService {
  click$ = new ClickSubject(this.editor);
  constructor(private editor: EditorService) {}
}
